<template>
  <div class="app-detail-container">
    <div class="breadcrumbs mb-40">
      <div class="breadcrumb">
        <router-link :to="{ path: '/app-detail', query: { id: route.query.id }}">
          <div class="btn-back">
            <el-icon>
              <arrow-left />
            </el-icon>
            {{ $t('breadcrumb.back') }}
          </div>
        </router-link>
      </div>
    </div>
    <div class="app-detail-card">
      <div class="app-detail-content-edit mt-40">
        <div class="flex-container">
          <div class="title font-w-semi-bold mb-24 flex-grow-1"> Edit App </div>
          <el-popconfirm
            :confirm-button-text="$t('app_edit.accept_confirm')"
            :cancel-button-text="$t('app_edit.cancel_confirm')"
            icon-color="#626AEF"
            :title="$t('app_edit.delete_confirm_app')"
            @confirm="handleRevokeApp"
          >
            <template #reference>
              <el-button type="info">
                {{ $t('app_edit.btn_delete_app') }}
              </el-button>
            </template>
          </el-popconfirm>
        </div>
        <el-form
          label-position="top"
          :model="form"
          style="max-width: 100%"
        >
          <el-form-item label="App Name">
            <el-input v-model="form.store_url_id" disabled />
          </el-form-item>
          <el-form-item label="App Category">
            <el-select
              v-model="form.category_id"
              placeholder="Select catgeory"
              style="width:100%;"
            >
              <el-option
                v-for="item in form.categories"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="App Tag">
            <el-select-v2
              v-model="form.tag_selected"
              :options="form.tags"
              :multiple-limit="10"
              :reserve-keyword="false"
              placeholder="Please select"
              style="width: 100%; vertical-align: middle"
              allow-create
              filterable
              multiple
              clearable
            />
          </el-form-item>
          <el-form-item label="Secret Key" class="secret_key">
            <el-input v-model="form.secret_key" readonly>
              <template #append>
                <el-icon class="font-18 color-black" @click="loadSecret()">
                  <refresh class="mt-8" />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="App Description">
            <el-input
              v-model="form.description"
              :autosize="{ minRows: 4}"
              type="textarea"
              placeholder="Maximum 250 characters"
            />
          </el-form-item>
          <el-form-item label="App Logo">
            <el-row>
              <el-col :span="24" style="border: 1px solid #ddd; border-radius: 4px;">
                <el-card
                  class="app-logo"
                  :body-style="{ padding: '4px', width: '668px' }"
                  style="box-shadow: none;"
                >
                  <template v-if="form.app_logo && !previewImage">
                    <div class="layout-vertical-center">
                      <img :src="form.app_logo" height="200" />
                      <input
                        ref="file"
                        type="file"
                        hidden
                        @change="onFileSelected"
                      />
                      <div class="mt-14 mb-14">
                        <el-button size="small" @click.prevent="$refs.file.click()">
                          <span class="font-w-bold">
                            {{ $t('app_edit.change_logo') }}
                          </span>
                        </el-button>
                        <el-popconfirm
                          :confirm-button-text="$t('app_edit.accept_confirm')"
                          :cancel-button-text="$t('app_edit.cancel_confirm')"
                          icon-color="#626AEF"
                          :title="$t('app_edit.delete_confirm_logo')"
                          @confirm="deleteFileSelected"
                        >
                          <template #reference>
                            <el-button size="small">
                              <span class="font-w-bold color-red">{{ $t('app_edit.delete') }}</span>
                            </el-button>
                          </template>
                        </el-popconfirm>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="previewImage">
                    <div class="layout-vertical-center">
                      <img v-if="form.app_logo != null" class="mt-16" :src="previewImage" height="200" />
                      <img v-else class="mt-16" :src="form.app_logo" height="200" />
                      <input
                        ref="file"
                        type="file"
                        hidden
                        @change="onFileSelected"
                      />
                      <div class="mt-14 mb-14">
                        <el-button size="small" @click.prevent="$refs.file.click()">
                          <span class="font-w-bold">
                            {{ $t('app_edit.change_logo') }}
                          </span>
                        </el-button>
                        <el-popconfirm
                          :confirm-button-text="$t('app_edit.accept_confirm')"
                          :cancel-button-text="$t('app_edit.cancel_confirm')"
                          icon-color="#626AEF"
                          :title="$t('app_edit.delete_confirm_logo')"
                          @confirm="deleteFileSelected"
                        >
                          <template #reference>
                            <el-button size="small">
                              <span class="font-w-bold color-red">{{ $t('app_edit.delete') }}</span>
                            </el-button>
                          </template>
                        </el-popconfirm>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="layout-vertical-center">
                      <img class="mt-28 mb-14" src="/img/icons/upload.svg" height="40" />
                      <span class="color-gray-dark mb-4">
                        {{ $t('app_edit.choose_file_type') }}
                      </span>
                      <span>.png/.jpg/.jpeg</span>
                      <input
                        ref="file"
                        type="file"
                        hidden
                        @change="onFileSelected"
                      />
                      <el-button
                        size="small"
                        class="mt-14 mb-14"
                        @click.prevent="$refs.file.click()"
                      >
                        <span class="font-w-bold">
                          {{ $t('app_edit.select_file') }}
                        </span>
                      </el-button>
                    </div>
                  </template>
                </el-card>
              </el-col>
            </el-row>
          </el-form-item>
          <div class="handle-button">
            <el-button class="btn-cancel" @click="handleDetailApp">
              {{ $t('app_edit.btn_cancel') }}
            </el-button>
            <el-button
              :loading="loading"
              class="btn-submit"
              type="success"
              @click="handleUpdateApp"
            >
              {{ $t('app_edit.btn_save') }}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  detailPairingStore,
  categoryApp,
  tagsApp,
  revokeApp,
  updateSecret,
  updatePairingStore
} from '@/api/endpoints/catalog/authOlsera.js'
import { onMounted, ref, reactive } from 'vue'
import { ArrowLeft, Refresh } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const previewImage = ref(null)
const form = reactive({
  id: '',
  openapi_id: '',
  store_url_id: '',
  category_id: '',
  categories: [],
  tag_selected: [],
  tags: [],
  secret_key: '',
  description: '',
  app_logo: ''
})

onMounted(() => {
  getCategory()
  getTags()
  getDataDetailPairing()
})

const getDataDetailPairing = () => {
  detailPairingStore(route.query).then((response) => {
    const data = response.data.data
    form.id = data.id
    form.openapi_id = data.openapi_id
    form.store_url_id = data.store_url_id
    form.category_id = data.category_id
    form.secret_key = data.secret_key
    form.description = data.description
    form.app_logo = data.app_logo_md
    if (data.tags) {
      data.tags.forEach(item => {
        form.tag_selected.push(item.name)
      })
    }
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
  })
}
const getCategory = () => {
  categoryApp().then(response => {
    form.categories = response.data
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
  })
}
const getTags = () => {
  tagsApp().then(response => {
    response.data.forEach(item => {
      form.tags.push({
        label: item.name,
        value: item.name
      })
    })
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
  })
}
const loadSecret = () => {
  updateSecret(form.id).then((response) => {
    form.secret_key = response.data.data.secret_key
    ElMessage({
      type: 'success',
      message: 'Secret key updated!'
    })
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
  })
}
const onFileSelected = (e) => {
  form.app_logo = e.target.files[0]
  previewImage.value = URL.createObjectURL(form.app_logo)
}
const deleteFileSelected = () => {
  previewImage.value = null
  form.app_logo = null
}
const handleUpdateApp = () => {
  loading.value = true
  const formData = new FormData()
  if (previewImage.value !== null) {
    formData.append('app_logo', form.app_logo)
  } else {
    formData.append('app_logo', '')
  }
  formData.append('id', form.id)
  formData.append('store_url_id', form.store_url_id)
  formData.append('category_id', form.category_id)
  formData.append('description', form.description)
  form.tag_selected.forEach((item) => formData.append('tags[]', item))
  updatePairingStore(form.id, formData).then((response) => {
    ElMessage({
      type: 'success',
      message: t('app_edit.app_updated')
    })
    loading.value = false
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
    loading.value = false
  })
}
const handleRevokeApp = () => {
  revokeApp(form).then((response) => {
    ElMessage({
      type: 'success',
      message: t('app_edit.app_deleted')
    })
    router.push({ path: '/console/app-list' })
    loading.value = false
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
    loading.value = false
  })
}
const handleDetailApp = () => {
  router.push({ path: '/app-detail', query: { id: route.query.id }})
}
</script>
